import React from 'react';
import { BenefitsSection } from '../components/BenefitsSection';
import { BonusesSection } from '../components/BonusesSection';
import { CountdownSection } from '../components/CountdownSection';
import { FaqSection } from '../components/FaqSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { OfferSection } from '../components/OfferSection';
import { ProblemSection } from '../components/ProblemSection';
import { SiteFooter } from '../components/SiteFooter';
import { StickyCta } from '../components/StickyCta';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { VolumesSection } from '../components/VolumesSection';

/**
 * Everything under the hero. Loaded as a separate chunk so the first paint only
 * needs the hero's code.
 */
export function BelowFold() {
  return <>
      <main data-id="element-194" data-mp="1evvs75yerhnj">
        <ProblemSection data-id="element-195" data-mp="1ev2suq1s3uff" />
        <BenefitsSection data-id="element-196" data-mp="1euuip5x1j37x" />
        <VolumesSection data-id="element-197" data-mp="32az7kw9z1e7g" />
        <BonusesSection data-id="element-198" data-mp="32afsrofmb5xn" />
        <CountdownSection data-id="element-199" data-mp="32caayuzi8jy1" />
        <OfferSection data-id="element-200" data-mp="32d27c80xelpd" />
        <GuaranteeSection data-id="element-201" data-mp="379snevcqdhas" />
        <TestimonialsSection data-id="element-202" data-mp="37abxjpw531e9" />
        <FaqSection data-id="element-203" data-mp="379ailac05ur9" />
        <FinalCtaSection data-id="element-204" data-mp="37bwnf27idw5s" />
      </main>
      <SiteFooter data-id="element-205" data-mp="2slxsd8b930uj" />
      <StickyCta data-id="element-206" data-mp="2skee1n95mzve" />
    </>;
}